<div class="ui-g">
    <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12 nuty-color">
        <p-panel header="{{ 'invoice_details' | translate }}" [toggleable]="false" [collapsed]="false"
            [style]="{'margin-bottom':'10px'}">
            <invoice-details-list></invoice-details-list>
        </p-panel>
    </div>
</div>